
/**
 * Main puzzle operations module - exclusively focused on external data sources
 */
import { getTodayUTC } from '../utils/date-utils';
import type { PuzzleData } from '../types/puzzle-types';
import { getPuzzleForDate, storePuzzleForDate } from '../database/puzzle-db';

// Variable to store external puzzle data that can be set
let externalPuzzleOverride: PuzzleData | null = null;

// Function to set external puzzle data
export function setExternalPuzzleData(puzzleData: PuzzleData | null): void {
  console.log('Setting external puzzle data:', puzzleData ? 
    `Rule: ${puzzleData.correctRule.name}, Words: ${puzzleData.words.length}` : 'None');
  externalPuzzleOverride = puzzleData;
}

export async function getTodaysPuzzle(forceRefresh = false): Promise<PuzzleData> {
  // Check if we have externally provided puzzle data
  if (externalPuzzleOverride) {
    console.log('Using externally provided puzzle data');
    return externalPuzzleOverride;
  }

  const utcDate = getTodayUTC();
  console.log('Getting puzzle for UTC date:', utcDate, 'Force refresh:', forceRefresh);
  
  // If forceRefresh is true, clear the localStorage cache
  if (forceRefresh) {
    console.log('Force refreshing puzzle - clearing localStorage cache');
    localStorage.removeItem('daily_puzzle');
    localStorage.removeItem('puzzle_date');
    localStorage.removeItem('current_puzzle');
    localStorage.removeItem('puzzle_cache_time');
  }
  
  // Try to get the puzzle from the database
  const puzzleFromDb = await getPuzzleForDate(utcDate);
  if (puzzleFromDb) {
    console.log('Retrieved puzzle from database');
    return puzzleFromDb;
  }
  
  // We should never reach here with proper configuration
  throw new Error("No puzzle data available. Please check your spreadsheet configuration.");
}

// Remove predefined puzzle functionality completely
export function toggleDay1Forcing(): { forced: boolean, message: string } {
  return {
    forced: false,
    message: "This feature is not available as all puzzles are sourced from Google Sheets"
  };
}
